module.exports = __webpack_public_path__ + "img/exchange.d4fdaa40.svg";